import { useScheduleProps } from './Types'
import { BrandPlanSchedule, BrandPlanScheduleCrosspost } from 'types'
import { useQueryClient } from 'react-query'
import { TransformedBrandPlanSchedule } from 'screens/BrandKits/components/BrandPlanTimeline/Types'
import { transformSchedule } from 'screens/BrandKits/components/BrandPlanTimeline/useTransformedBrandPlanSchedules'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Options, usePollPreparingBrandPlanSchedule } from 'hooks/queries/schedules/usePollPreparingBrandPlanSchedule'
import { CacheData, findScheduleInCache } from 'hooks/queries/schedules/useBrandPlanSchedule'

export const usePreparedSchedule = ({ scheduleId }: useScheduleProps, options?: Omit<Options, 'select'>) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()
  const cacheData = queryClient.getQueriesData<CacheData<BrandPlanScheduleCrosspost>>([
    'workspaces',
    workspaceId,
    'schedules',
    'list',
  ])

  return usePollPreparingBrandPlanSchedule<BrandPlanSchedule, TransformedBrandPlanSchedule>(scheduleId, {
    placeholderData: () => findScheduleInCache(cacheData, scheduleId),
    select: transformSchedule,
    ...options,
  })
}
